import { render, staticRenderFns } from "./CollectionFilterControlTypeRelationshipManyToMany.vue?vue&type=template&id=3810e6d6"
import script from "./CollectionFilterControlTypeRelationshipManyToMany.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeRelationshipManyToMany.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports